/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, LinearProgress, Paper, Stack, Typography, useTheme } from "@mui/material"
import useRoutes from '@/hooks/useRoutes';
import { useContext, useEffect, useState } from "react";
import BackIcon from '@mui/icons-material/West';
import { WebsiteContext } from "@/pages/website/WebsiteProvider";

const INITIAL_VALUE = 100;

const ThanksView = () => {
    const [navigate] = useRoutes();
    const { palette } = useTheme();
    const { organization } = useContext(WebsiteContext);
    const [remainingTime, setRemainingTime] = useState(INITIAL_VALUE);
    
    useEffect(() => {        
        const interval = setInterval(() => {
            setRemainingTime((prev) => {
                if (prev > 0) {
                    return prev - 1
                } else {
                    navigate('organizations.menu.main');
                }
                return prev;
            });
        }, 100);
        
        return () => {
            clearInterval(interval);
        }
    }, [])
    
    return (
        <Stack flex={1} sx={{ height: '100%', backgroundColor: palette.primary.light }}>
            <LinearProgress variant="determinate" color="primary" value={remainingTime} sx={{ height: 8 }} />
            <Stack flex={1} justifyContent="center" alignItems="center">
                <Typography fontSize="5rem">🙌</Typography>
                <Typography
                    variant="body1"
                    textAlign="center"
                >
                    orden completada
                </Typography>
                <Typography
                    variant="h2"
                    textAlign="center"
                    fontSize="3rem"
                    fontWeight={600}
                >¡Gracias por tu<br/>Preferencia!</Typography>
            </Stack>
            <Paper square elevation={2} sx={{ borderTopLeftRadius: '32px', borderTopRightRadius: '32px' }}>
                <Stack alignItems="center" padding={3} spacing={2}>
                    {organization?.logo ? (
                        <Box py={3}>
                            <img width={200} title={organization?.title ?? ''} src={organization.logo} />
                        </Box>
                    ) : null}
                    <Button
                        startIcon={<BackIcon />}
                        size="large"
                        fullWidth
                        onClick={() => navigate('organizations.menu.main')}
                    >
                        Regresar
                    </Button>
                </Stack>
            </Paper>
        </Stack>
    )
}

export default ThanksView;
